import qs from 'qs'
import request from '@/utils/request'
import { exportFile } from '@/utils/fileExport'

// 头像上传（服务端中转到腾讯云）
export function uploadFileToTxCloud (file) {
  const formData = new FormData()
  formData.append('file', file)
  return request({
    url: '/tx-cloud-file/uploadFileToTxCloudAiCourse',
    method: 'post',
    data: formData
  })
}

// 认证
export function doLogin (data) {
  return request({
    url: '/rtUser/doLogin',
    method: 'post',
    data: qs.stringify(data)
  })
}

export function getRtUserDetailsRefresh () {
  return request({
    url: '/rtUser/getRtUserDetailsRefresh',
    method: 'post'
  })
}

// 修改密码
export function updateRtUserPw (data) {
  return request({
    url: '/rtUser/updateRtUserPw',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 通知
export function getSysNoticeUnReadNum () {
  return request({
    url: '/sysNotice/getSysNoticeUnReadNum',
    method: 'post'
  })
}

export function getSysNoticeList (data) {
  return request({
    url: '/sysNotice/getSysNoticeList',
    method: 'post',
    data: qs.stringify(data)
  })
}

export function updateSysNoticeRead (noticeIds) {
  return request({
    url: '/sysNotice/updateSysNoticeRead',
    method: 'post',
    data: qs.stringify({ noticeIds: JSON.stringify(noticeIds) })
  })
}

export function updateSysNoticeReadAll () {
  return request({
    url: '/sysNotice/updateSysNoticeReadAll',
    method: 'post'
  })
}

export function deleteSysNoticeRead (noticeIds) {
  return request({
    url: '/sysNotice/deleteSysNoticeRead',
    method: 'post',
    data: qs.stringify({ noticeIds: JSON.stringify(noticeIds) })
  })
}

// ==================== 系统反馈 ====================

// 用户-提交系统反馈
export function addSysFeedback (data) {
  return request({
    url: '/sysFeedback/addSysFeedback',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 用户-查询自己的反馈列表
export function getSysFeedbackListUser (data) {
  return request({
    url: '/sysFeedback/getSysFeedbackListUser',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 管理员-查询所有反馈列表
export function getSysFeedbackList (data) {
  return request({
    url: '/sysFeedback/getSysFeedbackList',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 管理员-处理系统反馈
export function updateSysFeedbackHandler (data) {
  return request({
    url: '/sysFeedback/updateSysFeedbackHandler',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 管理员-删除系统反馈
export function deleteSysFeedback (data) {
  return request({
    url: '/sysFeedback/deleteSysFeedback',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 日志
export function getSysLogList (data) {
  return request({
    url: '/sysLog/getSysLogList',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 全局异常记录 - 获取列表
export function getSysMsgErrorGlobalList (data) {
  return request({
    url: '/sysMsgErrorGlobal/getSysMsgErrorGlobalList',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 全局异常记录 - 标记已处理
export function updateSysMsgErrorGlobalStatus (data) {
  return request({
    url: '/sysMsgErrorGlobal/updateSysMsgErrorGlobalStatus',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 日志活跃统计 - 获取统计列表
export function getSysLogStatisticsList (data) {
  return request({
    url: '/sysLogStatistics/getSysLogStatisticsList',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 日志活跃统计 - 获取时间段详情
export function getSysLogStatisticsDetails (data) {
  return request({
    url: '/sysLogStatistics/getSysLogStatisticsDetails',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 全量日志（备份表） - 获取列表
export function getSysLogCopyList (data) {
  return request({
    url: '/sysLogCopy/getSysLogCopyList',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 全量日志 - 日志迁移
export function updateSysLogCopyDo (data) {
  return request({
    url: '/sysLogCopy/updateSysLogCopyDo',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 报告
export function getPlaceholderReportList () {
  return Promise.resolve({ data: [] })
}

// ==================== 模板文件 ====================

// 模板文件列表（分页，支持按类型和名称筛选）
export function getRtReportModelFileList (data) {
  return request({
    url: '/rtReportModelFile/getRtReportModelFileList',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 模板文件详情
export function getRtReportModelFileDetails (data) {
  return request({
    url: '/rtReportModelFile/getRtReportModelFileDetails',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 新增模板文件
export function addRtReportModelFile (data) {
  return request({
    url: '/rtReportModelFile/addRtReportModelFile',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 编辑模板文件
export function updateRtReportModelFile (data) {
  return request({
    url: '/rtReportModelFile/updateRtReportModelFile',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 删除模板文件（软删除）
export function deleteRtReportModelFile (data) {
  return request({
    url: '/rtReportModelFile/deleteRtReportModelFile',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 分页响应标准化（模板文件复用）
export function normalizeModelFilePageResponse (res) {
  return {
    list: Array.isArray(res && res.data) ? res.data : [],
    total: Number((res && res.total) || 0),
    raw: res
  }
}

// ==================== 报告包申请记录（用户端） ====================

// 用户端看板统计（含5项统计指标 + 任务列表，支持日期范围筛选）
export function getRtStatisticsModelApplyUserAll (data = {}) {
  return request({
    url: '/rtStatistics/getRtStatisticsModelApplyUserAll',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 管理员端看板统计（全公司维度统计，支持日期范围筛选）
export function getRtStatisticsModelApplyAdmin (data = {}) {
  return request({
    url: '/rtStatistics/getRtStatisticsModelApplyAdmin',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 管理员端-待办提醒（今日待交付、逾期未交付、待审核列表）
export function getRtStatisticsModelApplyTodo () {
  return request({
    url: '/rtStatistics/getRtStatisticsModelApplyTodo',
    method: 'post'
  })
}

// 管理员端-模板使用排行榜（按申请/导出/修正次数排行）
export function getRtStatisticsModelApplyRank () {
  return request({
    url: '/rtStatistics/getRtStatisticsModelApplyRank',
    method: 'post'
  })
}

// 管理员端-效率统计（申请审批平均耗时、生成报告平均耗时）
export function getRtStatisticsModelApplyEfficiency () {
  return request({
    url: '/rtStatistics/getRtStatisticsModelApplyEfficiency',
    method: 'post'
  })
}

// ==================== 首页看板-常用功能（用户收藏模块记录） ====================

// 查询当前用户的常用功能记录（不存在则后端自动新增），返回 { rumcId, auId, rumcModel }
export function getRtUserModelCollect () {
  return request({
    url: '/rtUserModelCollect/getRtUserModelCollect',
    method: 'post'
  })
}

// 保存常用功能：rumcId 记录id，rumcModel 模块（逗号分隔的 authId 字符串）
export function updateRtUserModelCollect (data = {}) {
  return request({
    url: '/rtUserModelCollect/updateRtUserModelCollect',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 申请记录状态分组（当前用户）
export function getRtReportModelApplyStatusGroupUser (data = {}) {
  return request({
    url: '/rtReportModelApplyUser/getRtReportModelApplyStatusGroup',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 申请记录列表（分页，自动按当前用户过滤）
export function getRtReportModelApplyListUser (data) {
  return request({
    url: '/rtReportModelApplyUser/getRtReportModelApplyListUser',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 级联查询参数（客户群体/省份/地市/课程类型）
export function getRtReportModelListParamUser (data) {
  return request({
    url: '/rtReportModelApplyUser/getRtReportModelListParamUser',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 申请记录详情
export function getRtReportModelApplyDetailsUser (data) {
  return request({
    url: '/rtReportModelApplyUser/getRtReportModelApplyDetailsUser',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 新增申请记录（自动匹配报告包）
export function addRtReportModelApplyUser (data) {
  return request({
    url: '/rtReportModelApplyUser/addRtReportModelApplyUser',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 编辑申请记录（仅待提交状态可编辑）
export function updateRtReportModelApplyUser (data) {
  return request({
    url: '/rtReportModelApplyUser/updateRtReportModelApplyUser',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 提交申请记录（待提交 → 待审核）
export function submitRtReportModelApplyUser (data) {
  return request({
    url: '/rtReportModelApplyUser/submitRtReportModelApplyUser',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 删除申请记录（仅待提交状态可删除）
export function deleteRtReportModelApplyUser (data) {
  return request({
    url: '/rtReportModelApplyUser/deleteRtReportModelApplyUser',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 查询签到表识别记录列表
export function getRtReportModelUserSignOcrList (data) {
  return request({
    url: '/rtReportModelUserSignOcr/getRtReportModelUserSignOcrList',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 查询签到表识别记录详情
export function getRtReportModelUserSignOcrDetails (data) {
  return request({
    url: '/rtReportModelUserSignOcr/getRtReportModelUserSignOcrDetails',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 上传签到表并创建识别记录（文件流上传，字段名固定为 rrmaId + file）
export function addRtReportModelUserSignOcr ({ rrmaId, file }) {
  const formData = new FormData()
  formData.append('rrmaId', rrmaId)
  formData.append('file', file)

  return request({
    url: '/rtReportModelUserSignOcr/addRtReportModelUserSignOcr',
    method: 'post',
    data: formData
  })
}

// 导出签到表识别结果（通用文件流导出，自动识别文件名）
export function exportRtReportModelUserSignOcr (data) {
  return exportFile({
    url: '/rtReportModelUserSignOcr/exportRtReportModelUserSignOcr',
    data,
    defaultFileName: '签到表识别结果.xlsx'
  })
}

// 编辑签到表识别记录（提交修改后的 ocrTextUser JSON 字符串）
export function updateRtReportModelUserSignOcr (data) {
  return request({
    url: '/rtReportModelUserSignOcr/updateRtReportModelUserSignOcr',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 删除签到表识别记录
export function deleteRtReportModelUserSignOcr (data) {
  return request({
    url: '/rtReportModelUserSignOcr/deleteRtReportModelUserSignOcr',
    method: 'post',
    data: qs.stringify(data)
  })
}

// ==================== 签到表识别整合-考试（多条，独立 Controller） ====================
// 后端变更：原 addOrUpdateRtReportModelUserSignMergeExam 已废弃，拆为 add / update 两个接口；
// 路径前缀由 /rtReportModelUserSignMerge 迁移到 /rtReportModelUserSignMergeExam；
// 主键三件套：rrmusmId=整合主表、rrmusmExamId=单条考试记录、rrmusmRatingId=单条评估记录

// 查询签到表识别整合列表（按 rrmaId 过滤，返回主对象下挂 rtReportModelUserSignMergeExamList 多条考试）
export function getRtReportModelUserSignMergeList (data) {
  return request({
    url: '/rtReportModelUserSignMerge/getRtReportModelUserSignMergeList',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 新增一条考试成绩记录（上传考试表文件流，参数为 rrmusmId 整合主表id）
export function addRtReportModelUserSignMergeExam ({ rrmusmId, file }) {
  const formData = new FormData()
  formData.append('rrmusmId', rrmusmId)
  formData.append('file', file)
  return request({
    url: '/rtReportModelUserSignMergeExam/addRtReportModelUserSignMergeExam',
    method: 'post',
    data: formData
  })
}

// 编辑单条考试成绩记录（按 rrmusmExamId 更新，重新上传 excel）
export function updateRtReportModelUserSignMergeExam ({ rrmusmExamId, file }) {
  const formData = new FormData()
  formData.append('rrmusmExamId', rrmusmExamId)
  formData.append('file', file)
  return request({
    url: '/rtReportModelUserSignMergeExam/updateRtReportModelUserSignMergeExam',
    method: 'post',
    data: formData
  })
}

// 删除单条考试成绩记录（按 rrmusmExamId 软删，后端会重新合并剩余考试到 signAddExam）
export function deleteRtReportModelUserSignMergeExam (data) {
  return request({
    url: '/rtReportModelUserSignMergeExam/deleteRtReportModelUserSignMergeExam',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 导出签到表考试整合 Excel（按整合主表 rrmusmId 导出，导出的是所有考试合并后的 signAddExam）
export function exportRtReportModelUserSignMergeSignExam (data) {
  return exportFile({
    url: '/rtReportModelUserSignMergeExam/exportRtReportModelUserSignMergeSignExam',
    data,
    defaultFileName: '签到表考试整合.xlsx'
  })
}

// 签到表考试整合导出excel-使用模板
export function exportRtReportModelUserSignMergeSignExamUseModel (data) {
  return exportFile({
    url: '/rtReportModelUserSignMergeExam/exportRtReportModelUserSignMergeSignExamUseModel',
    data,
    defaultFileName: '签到表考试整合(模板).xlsx'
  })
}

// 编辑签到表考试整合数据（提交完整 signAddExam JSON 字符串）
export function updateRtReportModelUserSignMergeSignUser (data) {
  return request({
    url: '/rtReportModelUserSignMerge/updateRtReportModelUserSignMergeSignUser',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 删除考勤整合数据（清空 signAddExam 字段）
export function deleteRtReportModelUserSignMergeSignAddExam (data) {
  return request({
    url: '/rtReportModelUserSignMerge/deleteRtReportModelUserSignMergeSignAddExam',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 删除评估数据（清空 ratingUp 字段）
export function deleteRtReportModelUserSignMergeRating (data) {
  return request({
    url: '/rtReportModelUserSignMerge/deleteRtReportModelUserSignMergeRating',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 清空考勤、评估和报告数据
export function deleteRtReportModelUserSignMergeAll (data) {
  return request({
    url: '/rtReportModelUserSignMerge/deleteRtReportModelUserSignMergeAll',
    method: 'post',
    data: qs.stringify(data)
  })
}

// ==================== 签到表识别整合-评分（多条，独立 Controller） ====================
// 后端变更：原 addOrUpdateRtReportModelUserSignMergeRating 已废弃，拆为 add / update；
// 路径前缀迁移到 /rtReportModelUserSignMergeRating；新增了 add...RatingTwentyFive；
// 评分子记录主键为 rrmusmRatingId，原走 rrmusmId 的接口现已改为 rrmusmRatingId。

// 编辑签到表识别整合-只整合签到数据（无需上传文件，按 rrmaId 整合已有签到表记录）
export function updateRtReportModelUserSignMergeOnlySign (data) {
  return request({
    url: '/rtReportModelUserSignMerge/updateRtReportModelUserSignMergeOnlySign',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 新增一条普通评分记录（ratingUpType=1，上传评分表文件流，参数为 rrmusmId 整合主表id）
export function addRtReportModelUserSignMergeRating ({ rrmusmId, file }) {
  const formData = new FormData()
  formData.append('rrmusmId', rrmusmId)
  formData.append('file', file)
  return request({
    url: '/rtReportModelUserSignMergeRating/addRtReportModelUserSignMergeRating',
    method: 'post',
    data: formData
  })
}

// 编辑单条普通评分记录（按 rrmusmRatingId 更新，重新上传 excel）
export function updateRtReportModelUserSignMergeRating ({ rrmusmRatingId, file }) {
  const formData = new FormData()
  formData.append('rrmusmRatingId', rrmusmRatingId)
  formData.append('file', file)
  return request({
    url: '/rtReportModelUserSignMergeRating/updateRtReportModelUserSignMergeRating',
    method: 'post',
    data: formData
  })
}

// 删除单条评估记录（按 rrmusmRatingId 软删，独立 Controller）
// 注意：与清空全部接口同名但路径前缀不同，故单独命名以避免覆盖
export function deleteRtReportModelUserSignMergeRatingSingle (data) {
  return request({
    url: '/rtReportModelUserSignMergeRating/deleteRtReportModelUserSignMergeRating',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 导出单条评分数据 Excel（按 rrmusmRatingId 导出该条 ratingUp；25模板不可导出）
export function exportRtReportModelUserSignMergeRating (data) {
  return exportFile({
    url: '/rtReportModelUserSignMergeRating/exportRtReportModelUserSignMergeRating',
    data,
    defaultFileName: '评分数据.xlsx'
  })
}

// 评分数据导出excel-使用模板（按 rrmusmRatingId）
export function exportRtReportModelUserSignMergeRatingUseModel (data) {
  return exportFile({
    url: '/rtReportModelUserSignMergeRating/exportRtReportModelUserSignMergeRatingUseModel',
    data,
    defaultFileName: '评分数据(模板).xlsx'
  })
}

// 编辑评分数据-删除列（按 rrmusmRatingId；indexJson 为选中列下标数组的 JSON 字符串，如 "[1,2]"）
export function updateRtReportModelUserSignMergeRatingCol (data) {
  return request({
    url: '/rtReportModelUserSignMergeRating/updateRtReportModelUserSignMergeRatingCol',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 新增一条25项评分记录（ratingUpType=2，手动输入；参数为 rrmusmId + ratingUp 评分数据JSON）
export function addRtReportModelUserSignMergeRatingTwentyFive (data) {
  return request({
    url: '/rtReportModelUserSignMergeRating/addRtReportModelUserSignMergeRatingTwentyFive',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 编辑25项评分记录（按 rrmusmRatingId；ratingUp 为评分数据 JSON 字符串）
export function updateRtReportModelUserSignMergeRatingTwentyFive (data) {
  return request({
    url: '/rtReportModelUserSignMergeRating/updateRtReportModelUserSignMergeRatingTwentyFive',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 训战业绩-保存（业绩图片URL + 业绩文字说明）
// 接口参数均为 query 形式：rrmusmId(必填) / achievementDes(业绩说明) / achievementImage(业绩图片URL)
export function updateRtReportModelUserSignMergeWordAchievement (data) {
  return request({
    url: '/rtReportModelUserSignMerge/updateRtReportModelUserSignMergeWordAchievement',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 签到表识别整合详情
export function getRtReportModelUserSignMergeDetails (data) {
  return request({
    url: '/rtReportModelUserSignMerge/getRtReportModelUserSignMergeDetails',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 获取讲师简介-AI优化
export function getRtReportModelUserSignMergeWordTeacher (data) {
  return request({
    url: '/rtReportModelUserSignMerge/getRtReportModelUserSignMergeWordTeacher',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 获取讲师简介-用户修改AI优化
export function updateRtReportModelUserSignMergeWordTeacher (data) {
  return request({
    url: '/rtReportModelUserSignMerge/updateRtReportModelUserSignMergeWordTeacher',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 获取正文-AI优化
export function getRtReportModelUserSignMergeWordText (data) {
  return request({
    url: '/rtReportModelUserSignMerge/getRtReportModelUserSignMergeWordText',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 上传文件并提取文本内容（支持 Word/Excel/PPT/PDF/文本文件）
export function getExtractFileText ({ file }) {
  const formData = new FormData()
  formData.append('file', file)
  return request({
    url: '/rtReportModelUserSignMerge/getExtractFileText',
    method: 'post',
    data: formData
  })
}

// 上传文件并通过AI智能提取课程大纲、讲师简介、其他补充三部分内容
export function getExtractFileTextAnalyzeAi ({ file }) {
  const formData = new FormData()
  formData.append('file', file)
  return request({
    url: '/rtReportModelUserSignMerge/getExtractFileTextAnalyzeAi',
    method: 'post',
    data: formData
  })
}

// 获取正文-用户修改AI优化（旧版，保留兼容；新报告模块改用 updateRtReportModelUserSignMergeWordParam）
export function updateRtReportModelUserSignMergeWordText (data) {
  return request({
    url: '/rtReportModelUserSignMerge/updateRtReportModelUserSignMergeWordText',
    method: 'post',
    data: qs.stringify(data)
  })
}

// ============ 报告内容记录（多课程模块）接口 ============
// 接口前缀：/rtReportModelUserSignMergeWord

// 获取正文-报告参数修改（课程名称/客户/培训对象/项目经理团队/项目团队联系方式/培训地点）
export function updateRtReportModelUserSignMergeWordParam (data) {
  return request({
    url: '/rtReportModelUserSignMerge/updateRtReportModelUserSignMergeWordParam',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 报告内容记录列表（按签到表识别整合id查询多条课程记录）
export function getRtReportModelUserSignMergeWordList (data) {
  return request({
    url: '/rtReportModelUserSignMergeWord/getRtReportModelUserSignMergeWordList',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 报告内容记录详情
export function getRtReportModelUserSignMergeWordDetails (data) {
  return request({
    url: '/rtReportModelUserSignMergeWord/getRtReportModelUserSignMergeWordDetails',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 新增报告内容记录-ai优化（submitStatus=1提交触发AI；=2暂存）
export function addRtReportModelUserSignMergeWordAi (data) {
  return request({
    url: '/rtReportModelUserSignMergeWord/addRtReportModelUserSignMergeWordAi',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 编辑报告内容记录-ai优化（submitStatus=1提交触发AI；=2暂存）
export function updateRtReportModelUserSignMergeWordAi (data) {
  return request({
    url: '/rtReportModelUserSignMergeWord/updateRtReportModelUserSignMergeWordAi',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 编辑报告内容记录-ai生成的部分（仅修改 ai优化的讲师简介 wordTeacherAi / 课程总结 wordCourseSummary）
export function updateRtReportModelUserSignMergeWord (data) {
  return request({
    url: '/rtReportModelUserSignMergeWord/updateRtReportModelUserSignMergeWord',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 删除报告内容记录（后端：第一个不允许删除）
export function deleteRtReportModelUserSignMergeWord (data) {
  return request({
    url: '/rtReportModelUserSignMergeWord/deleteRtReportModelUserSignMergeWord',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 总结报告-导出Word（使用模板，operationType=1 生成下载）
export function exportRtReportModelUserSignMergeReportWord (data) {
  return exportFile({
    url: '/rtReportModelUserSignMerge/exportRtReportModelUserSignMergeReportWord',
    data: { ...data, operationType: 1 },
    defaultFileName: '总结报告.docx'
  })
}

// 总结报告-预览（operationType=2，返回文件信息供 OnlyOffice 预览）
export function previewRtReportModelUserSignMergeReportWord (data) {
  return request({
    url: '/rtReportModelUserSignMerge/exportRtReportModelUserSignMergeReportWord',
    method: 'post',
    data: qs.stringify({ ...data, operationType: 2 })
  })
}

// 分页响应标准化（申请记录复用）
export function normalizeApplyPageResponse (res) {
  return {
    list: Array.isArray(res && res.data) ? res.data : [],
    total: Number((res && res.total) || 0),
    raw: res
  }
}

// ==================== 报告包申请记录（管理员端） ====================

// 管理员-级联查询参数（客户群体/省份/地市/课程类型）
export function getRtReportModelListParam (data) {
  return request({
    url: '/rtReportModel/getRtReportModelListParam',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 管理员-申请记录状态分组（全量）
export function getRtReportModelApplyStatusGroupAll (data = {}) {
  return request({
    url: '/rtReportModelApply/getRtReportModelApplyStatusGroupAll',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 管理员-申请记录列表（查看所有用户）
export function getRtReportModelApplyList (data) {
  return request({
    url: '/rtReportModelApply/getRtReportModelApplyList',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 管理员-申请记录详情
export function getRtReportModelApplyDetails (data) {
  return request({
    url: '/rtReportModelApply/getRtReportModelApplyDetails',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 管理员-编辑申请记录
export function updateRtReportModelApply (data) {
  return request({
    url: '/rtReportModelApply/updateRtReportModelApply',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 管理员-审核通过（待审核 → 已发包）
export function checkRtReportModelApply (data) {
  return request({
    url: '/rtReportModelApply/checkRtReportModelApply',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 管理员-删除申请记录
export function deleteRtReportModelApply (data) {
  return request({
    url: '/rtReportModelApply/deleteRtReportModelApply',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 管理员-新增申请记录（分配给指定用户）
export function addRtReportModelApply (data) {
  return request({
    url: '/rtReportModelApply/addRtReportModelApply',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 查询当前用户的纷享销客行程表销售订单号（用于申请时下拉选择）
export function getRtFxxkItineraryListApplyUsers (data) {
  return request({
    url: '/rtReportModelApplyUser/getRtFxxkItineraryListApplyUsers',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 根据销售订单号快速获取申请信息（客户群体、省份、地市、课程类型、包内含资料）
export function getRtReportModelParamUserInput (data) {
  return request({
    url: '/rtReportModelApplyUser/getRtReportModelParamUserInput',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 查询所有纷享销客行程表销售订单号（管理员端下拉选择）
export function getRtFxxkItineraryListAll (data) {
  return request({
    url: '/rtReportModelApply/getRtFxxkItineraryListAll',
    method: 'post',
    data: qs.stringify(data)
  })
}

// ==================== 纷享销客行程表记录 ====================

// 行程表记录列表（分页查询）
export function getRtFxxkItineraryList (data) {
  return request({
    url: '/rtFxxkItinerary/getRtFxxkItineraryList',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 行程表记录详情（含成员列表）
export function getRtFxxkItineraryDetails (data) {
  return request({
    url: '/rtFxxkItinerary/getRtFxxkItineraryDetails',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 行程表记录批量过期
export function updateRtFxxkItineraryStatusExpired (data) {
  return request({
    url: '/rtFxxkItinerary/updateRtFxxkItineraryStatusExpired',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 行程表数据同步（从外部服务拉取最新行程表）
export function updateRtFxxkItinerarySync (data) {
  return request({
    url: '/rtFxxkItinerary/updateRtFxxkItinerarySync',
    method: 'post',
    data: data ? qs.stringify(data) : undefined
  })
}

// ==================== OnlyOffice 文档编辑 ====================

// 获取 OnlyOffice 编辑器配置（GET，后端接口：/onlyoffice/config）
export function getOnlyOfficeConfig (params) {
  return request({
    url: '/onlyoffice/config',
    method: 'get',
    params
  })
}
